module.exports = __webpack_public_path__ + "77e950a4c7273f32f00333fd3dae2f5b.pdf";